import React from "react";
import { useHistory, withRouter } from "react-router-dom";
import { ROUTE } from "../misc";
import { buildUri } from "../misc";

import { event as searchUseEvent } from "../GA/ExploreProviders/SearchUse";
import { GeoEncoder } from "./GeoEncoder";

const LProviderSearchBox = () => {
    const history = useHistory();

    return (
        <>
            <GeoEncoder
                onChange={async item => {
                    if (!item?.data) return;
                    const { provider } = item?.data;
                    if (!provider) return;

                    const { adminId } = provider;
                    if (adminId == null) return;

                    const uri = buildUri(
                        ROUTE.PROVIDER_INFO,
                        {},
                        {
                            id: adminId
                        }
                    );

                    searchUseEvent(item.keyword);
                    history.push(uri);
                }}
            />
        </>
    );
};

export const ProviderSearchBox = withRouter(LProviderSearchBox);
